import { create } from 'zustand'

type TUserListStore = {
  searchValue: string
  setSearchValue: (value: string) => void
  resetSearchValue: () => void
}

export const useGlobalUserListStore = create<TUserListStore>()(set => ({
  searchValue: '',
  setSearchValue: searchValue => set({ searchValue }),
  resetSearchValue: () => set({ searchValue: '' })
}))
